/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { DeleteApiGreetingsIdMutationResponse, DeleteApiGreetingsIdPathParams, DeleteApiGreetingsId400, DeleteApiGreetingsId401, DeleteApiGreetingsId403, DeleteApiGreetingsId404, DeleteApiGreetingsId500 } from "../../types/DeleteApiGreetingsId.ts";
import { deleteApiGreetingsIdMutationResponseSchema } from "../../zod/GreetingsSchemas/deleteApiGreetingsIdSchema.ts";

function getDeleteApiGreetingsIdUrl({ id }: { id: DeleteApiGreetingsIdPathParams["Id"] }) {
  const res = { method: 'DELETE', url: `/api/greetings/${id}` as const }  
  return res
}

/**
 * @summary Удаление шаблона приветственного экрана
 * {@link /api/greetings/:Id}
 */
export async function deleteApiGreetingsId({ id }: { id: DeleteApiGreetingsIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeleteApiGreetingsIdMutationResponse, ResponseErrorConfig<DeleteApiGreetingsId400 | DeleteApiGreetingsId401 | DeleteApiGreetingsId403 | DeleteApiGreetingsId404 | DeleteApiGreetingsId500>, unknown>({ method : "DELETE", url : getDeleteApiGreetingsIdUrl({ id }).url.toString(), ... requestConfig })  
  return deleteApiGreetingsIdMutationResponseSchema.parse(res.data)
}